import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { GeologicalSampleService, NotificationService } from '@services';
import { catchError, of } from 'rxjs';

import { GeologicalSample } from '@models';

export const geologicalSampleResolver: ResolveFn<GeologicalSample | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const geologicalSampleService = inject(GeologicalSampleService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const geologicalSampleId = route.paramMap.get('id');
  if (!geologicalSampleId) {
    return of(null);
  }

  return geologicalSampleService.getSample(geologicalSampleId).pipe(
    catchError((err) => {
      console.error(err);

      switch (err?.status) {
        case 401:
          break;
        default:
          router.navigate(['/404'], {
            skipLocationChange: true,
          });
          notificationService.error('Failed to load the requested sample.');
          break;
      }

      return of(null);
    }),
  );
};
